module.exports = __webpack_public_path__ + "img/logo.538925eb.svg";